module.exports = __webpack_public_path__ + "static/media/icon-piece5-1.ba6d5529.png";